var map = {
	"./1_Thumbnail,title_ Operasi PRG Gagalkan Penyelundupan 309 Kg Sabu Jaringan Golden Crescent.jpg": 48760,
	"./2_Thumbnail,title_ BNN RI Apresiasi Pemprov Kepri Dalam Pemberantasan Narkoba.jpeg": 28306,
	"./3_Thumbnail,title_ Kepala BNN RI Hadiri Pengungkapan Kasus 1,129 Ton Sabu Jaringan Timur Tengah-Indonesia.jpg": 71984,
	"./4_Thumbnail,title_ Tahun 2021-2023, BNN RI dan BNNP Lampung Ungkap 44 Kasus dengan Aset Disita Rp 260,2 Miliar.jpg": 84800,
	"./5_Thumbnail,title_ BNN Sudah Selamatkan 12,2 Juta Anak Bangsa.jpg": 72365,
	"./6_Thumbnail,title_ Tujuh Jenderal BNN RI Turun Musnahkan Ladang Ganja.jpg": 38977,
	"./7_Thumbnail,title_ BNN RI amankan 110 kilogram sabu dari dua lokasi berbeda.jpg": 63345,
	"./8_Thumbnail,title_ BNN sita uang TPPU Rp187,5 miliar sejak 2021 hingga 2023.jpg": 68368,
	"./9_Thumbnail,title_ BNN RI musnahkan ratusan kilogram narkoba.jpg": 88105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55646;